const e = "data:image/svg+xml,%3csvg%20width='48'%20height='49'%20viewBox='0%200%2048%2049'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M4%205L43.5569%2044.598'%20stroke='%23B1B2B2'%20stroke-width='8'%20stroke-linecap='round'/%3e%3cpath%20d='M43.5586%205L4.00171%2044.598'%20stroke='%23B1B2B2'%20stroke-width='8'%20stroke-linecap='round'/%3e%3c/svg%3e";
export {
  e as default
};
//# sourceMappingURL=icon-cross.svg.js.map
